<template>
  <div class="user-card-content">
    <CardComponent ref="card" variant="tertiary">
      <template #header>
        Sessões ativas
        <ul class="actions top-right">
          <li>
            <a role="button" @click="fetch(1)">
              <span class="material-symbols-outlined"> refresh </span>
            </a>
          </li>
        </ul>
      </template>
      <TableComponent :busy="loading" :fields="fields" :items="sessions">
        <template #cell(pivot.role)="slotProps">
          {{ $tc(`app.${slotProps.data}`, 1) }}
        </template>
        <template #cell(pivot.is_agent)="slotProps">
          <span v-if="slotProps.data" class="material-symbols-outlined"> done </span>
        </template>
      </TableComponent>
      <PaginationComponent v-model="currentPage" :totalPages="totalPages" @change="fetch"/>
    </CardComponent>
  </div>
</template>

<script>
import PaginationComponent from '@/components/PaginationComponent.vue';
import axios from '@/plugins/axios';
import CardComponent from '@/components/CardComponent.vue';
import TableComponent from '@/components/TableComponent.vue';

const webApi = axios();

export default {
  name: 'UsersCard',
  components: {
    TableComponent,
    CardComponent,
    PaginationComponent,
  },
  data() {
    return {
      loading: true,
      updating: false,
      fields: [
        {
          key: 'ip_address',
          label: 'Endereço de IP',
        },
        {
          key: 'user_agent',
          label: 'User Agent',
        },
        {
          key: 'device',
          label: 'Dispositivo',
        },
        {
          key: 'last_active',
          label: 'Ativo desde',
        },
      ],
      tableFields: [
        {
          key: 'ip_address',
        },
        {
          key: 'user_agent',
        },
        {
          key: 'device',
          label: 'Dispositivo',
        },
        {
          key: 'last_active',
          label: 'Ativo desde',
        },
      ],
      totalPages: 1,
      fullscreen: false,
      q: '',
      page: 1,
      pages: 1,
      sessions: [],
      currentPage: 1,
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    this.$root.$on('UsersCardReload', () => {
      this.fetch();
    });
  },
  methods: {
    fetch(page = 1) {
      this.loading = true;
      this.currentPage = page;
      this.$store
        .dispatch('fetchUserSessions', { page: this.currentPage, q: this.q })
        .then((response) => {
          this.sessions = response.data;
          this.totalPages = response.last_page;
          this.loading = false;
        });
      this.agentsAmount();
    },
    changePage(page) {
      /* this.page = page;
      this.$emit('change-page', this.page); */
      this.fetch(page);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .pagination_row {
  display: none !important;
}

::v-deep {
  .user-card-content .modal {
    overflow-y: auto !important;
  }

  .table-responsive {
    overflow: visible;
  }
}
</style>
